import script from "./ClientBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientBadge.vue?vue&type=script&lang=ts&setup=true"

import "./ClientBadge.vue?vue&type=style&index=0&id=27ed587f&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ed587f"]])

export default __exports__